import { Action } from 'redux';
import { IndividualMarketStateStructure } from '../interfaces/individualMarket.interfaceStateStructure';

export const INDIVIDUAL_MARKET_STATE_NAME = 'individualMarket';

export const INITIAL_STATE: IndividualMarketStateStructure = {} as IndividualMarketStateStructure;

const APPLY_INDIVIDUAL_STATE = 'APPLY_FULL_INDIVIDUAL_STATE';

const CLEAR_INDIVIDUAL_MARKET_PAYLOAD_STATE = 'CLEAR_INDIVIDUAL_MARKET_PAYLOAD_STATE';

export class IndividualMarketAction implements Action {
    type: string;
    indMarketState?: IndividualMarketStateStructure;
}

export function saveIndividualState(indMarketState: IndividualMarketStateStructure) {
  return { type: APPLY_INDIVIDUAL_STATE, indMarketState};
}

export function clearIndividualMarketPayloadState(): IndividualMarketAction{
  return { type: CLEAR_INDIVIDUAL_MARKET_PAYLOAD_STATE }
}

export function IndividualMarket(
  state: IndividualMarketStateStructure = INITIAL_STATE,
  action: IndividualMarketAction
) {

  switch (action.type) {
    /** Save Plans From Service Response */
    case APPLY_INDIVIDUAL_STATE:
        return Object.assign({}, action.indMarketState);
    case CLEAR_INDIVIDUAL_MARKET_PAYLOAD_STATE:
        return {...INITIAL_STATE};
    default:
      return state;
  }
}
